const PrivacyPolicy = () => {
    return (
        <>
            <div id='tabs'>
                <div className="maintitle-box">
                    <div className="w-25 d-inline-block">
                        <h2 className="maintitle ">Privacy Policy</h2>
                    </div>
                </div>
                <div className="pp-padding">

                    <p className='pp mt-2'>
                        This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.
                    </p>

                    <p className='pp font-bold'>
                        What personal information do we collect from the people that visit our blog, website or app?
                    </p>

                    <p className='pp'>
                        When ordering or registering on our site, as appropriate, you may be asked to enter your phone number or other details to help you with your experience.
                    </p>

                    <p className='pp font-bold'>
                        When do we collect information?
                    </p>

                    <p className='pp'>
                        We collect information from you when you register on our site or enter information on our site.
                    </p>

                    <p className='pp font-bold'>

                        How do we use your information?
                    </p>

                    <p className='pp'>
                        We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:
                        <ul>
                            <li>
                                To allow us to better service you in responding to your customer service requests.
                            </li>
                        </ul>
                    </p>

                    <p className='pp font-bold'>
                        How do we protect your information?
                        We do not use vulnerability scanning and/or scanning to PCI standards.
                        We only provide articles and information. We never ask for credit card numbers.
                        We do not use Malware Scanning.
                        We do not use an SSL certificate
                    </p>
                    <ul>
                        <li>
                            We only provide articles and information. We never ask for personal or private information like names, email addresses, or credit card numbers.

                        </li>
                    </ul>

                    <p className='pp font-bold'>
                        Do we use 'cookies'?
                    </p>
                    <p>
                        We do not use cookies for tracking purposes
                    </p>
                    <p>
                        You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.
                    </p>
                    <p>
                        If you turn cookies off, Some of the features that make your site experience more efficient may not function properly.that make your site experience more efficient and may not function properly.
                    </p>

                    <p className='pp font-bold'>
                        Third-party disclosure
                    </p>
                    <p>
                        We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.
                    </p>
                    <p>

                        However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.
                    </p>

                    <p className='pp font-bold'>
                        Third-party links
                    </p>
                    <p>
                        We do not include or offer third-party products or services on our website.
                    </p>

                    <p className='pp font-bold'>
                        Google
                    </p>
                    <p>
                        Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users.<a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en" target="_blank" rel="noopener noreferrer" className='ml-2'>https://support.google.com/adwordspolicy/answer/1316548?hl=en</a>
                    </p>
                    <p>
                        We have not enabled Google AdSense on our site but we may do so in the future.
                    </p>

                    <p className='pp font-bold'>
                        California Online Privacy Protection Act
                    </p>
                    <p>
                        CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law's reach stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals or companies with whom it is being shared. - See more at: <a href='http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf' target='_blank' rel='noopener noreferrer' className='ml-2'>http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf</a>
                    </p>

                    <p className='pp font-bold'>
                        According to CalOPPA, we agree to the following:
                    </p>
                    <p>
                        Users can visit our site anonymously.
                    </p>
                    <p>
                        Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website.
                    </p>
                    <p>
                        Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified above.
                    </p>
                    <p>
                        You will be notified of any Privacy Policy changes:
                        <ul>
                            <li>
                                On our Privacy Policy Page

                            </li>
                        </ul>
                    </p>
                    <p>
                        Can change your personal information:
                        <ul>
                            <li>
                                By emailing us
                            </li>
                        </ul>
                    </p>

                    <p className='pp font-bold'>
                        How does our site handle Do Not Track signals?
                    </p>
                    <p>
                        We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.
                    </p>

                    <p className='pp font-bold'>
                        Does our site allow third-party behavioral tracking?
                    </p>
                    <p>
                        It's also important to note that we do not allow third-party behavioral tracking
                    </p>

                    <p className='pp font-bold'>
                        COPPA (Children Online Privacy Protection Act)
                    </p>
                    <p>
                        When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online.
                    </p>
                    <p>
                        We do not specifically market to children under the age of 13 years old.
                        Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?
                    </p>

                    <p className='pp font-bold'>
                        Fair Information Practices
                    </p>
                    <p>
                        The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information.
                    </p>

                    <p className='pp font-bold'>
                        In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:
                    </p>
                    <p>
                        We will notify you via email
                        <ul>
                            <li>
                                Within 1 business day
                            </li>
                        </ul>
                    </p>
                    <p>
                        We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.
                    </p>

                    <p className='pp font-bold'>
                        CAN SPAM Act
                    </p>
                    <p>
                        The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.
                    </p>

                    <p className='pp font-bold'>
                        We collect your email address in order to:
                    </p>
                    <p className='pp font-bold'>
                        To be in accordance with CANSPAM, we agree to the following:
                    </p>
                    <p className='pp font-bold'>
                        If at any time you would like to unsubscribe from receiving future emails, you can email us at
                        and we will promptly remove you from ALL correspondence.
                    </p>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy;